import { FC } from "react";

import { EditUserProfile } from "Auth/containers";
import { useProfileContext } from "Auth/contexts";

export const EditProfilePage: FC = () => {
  const { redirectToProfile } = useProfileContext();

  return <EditUserProfile showOtherInfo redirectAfterEdit={redirectToProfile} />;
};
